<template>
  <div class="menu-wrapper">
    <div class="nav-menu-wrapper">
      <nav-menu v-if="!isMobile">
        <menu-item />
      </nav-menu>
      <mobile-menu v-if="isMobile" />
    </div>
  </div>
</template>


<script>
import { mapState } from 'vuex';
import MobileMenu from '../components/Mobile/MobileMenu';
import NavMenu from '../pages/NavMenu';
import MenuItem from '../components/MenuItem';


export default {
  name: 'AppHeader',
  components: {
    MobileMenu,
    NavMenu,
    MenuItem,
  },
  computed: {
    ...mapState({
      isMobile: state => state.isMobile,
    }),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/AppHeader.vue